import { FirmInfoType } from '@/components/settings-page/platformSettings/firmInfo';
import * as docx from 'docx';
import { DefaultTheme } from 'styled-components/dist/types';
import { formatFirmAddress, formatFirmContactInfo } from '../../utils';
import { transparentDocxTableBorders } from '../utils';

export const getDocxFooter = (firmInfoData: FirmInfoType, theme: DefaultTheme) => {
  const footer = new docx.Footer({
    children: [
      new docx.Paragraph({
        spacing: {
          before: 400
        }
      }),
      new docx.Table({
        rows: [
          new docx.TableRow({
            children: [
              new docx.TableCell({
                children: [
                  ...(firmInfoData?.firmName && [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: firmInfoData.firmName,
                          bold: true,
                          color: theme.font.base
                        })
                      ],
                      spacing: { after: 150 },
                      alignment: docx.AlignmentType.CENTER
                    })
                  ]),
                  ...(formatFirmAddress(firmInfoData) && [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: formatFirmAddress(firmInfoData),
                          color: theme.font.weak
                        })
                      ],
                      spacing: { after: 50 },
                      alignment: docx.AlignmentType.CENTER
                    })
                  ]),
                  ...(formatFirmContactInfo(firmInfoData) && [
                    new docx.Paragraph({
                      children: [
                        new docx.TextRun({
                          text: formatFirmContactInfo(firmInfoData),
                          color: theme.font.weak
                        })
                      ],
                      alignment: docx.AlignmentType.CENTER
                    })
                  ])
                ],
                borders: transparentDocxTableBorders,
                width: {
                  size: 12000,
                  type: docx.WidthType.DXA
                },
                verticalAlign: docx.VerticalAlign.CENTER
              })
            ]
          })
        ]
      })
    ]
  });

  return footer;
};
